/** The canvas clock is intentionally independent from simulation progress. */
export const RENDER_TARGET_FPS = 60;

/** Worker frequency cap; each tick advances one fixed physics step. */
export const SIMULATION_TARGET_FPS = 30;
export const SIMULATION_STEP_SECONDS = 1 / SIMULATION_TARGET_FPS;
